// extracted by mini-css-extract-plugin
export default {"store-hours-info-text":"store-hours-info-text_JjTVAgQB"};